import { createContext, useContext } from 'react';

type ToolResultRenderer = (data: unknown, toolInputs?: unknown) => React.ReactNode;

/**
 * Context for providing custom tool result renderers.
 * Allows different parts of the application to inject domain-specific
 * rendering logic for tool outputs (e.g., observability tables, charts, etc.)
 *
 * No default value is provided — consumers must read it through
 * `useToolResultRendererContext`, which throws if the provider is missing.
 */
export const ToolResultRendererContext = createContext<ToolResultRenderer | null>(null);

export function useToolResultRendererContext(): ToolResultRenderer {
  const renderer = useContext(ToolResultRendererContext);
  if (renderer === null) {
    throw new Error(
      'useToolResultRendererContext must be used within a ToolResultRendererContext.Provider. ' +
        'Wrap your tree with ObservabilityDependencyAdapter (or supply your own provider) before rendering AgentInsights.',
    );
  }
  return renderer;
}
